/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featureaidesc3Inputs */

const zh_about_featureaidesc3 = /** @type {(inputs: About_Featureaidesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只需一句话描述教学需求，AI 便能生成动画、互动组件、实验模拟等丰富的教学内容，大幅降低创作门槛。`)
};

const en_about_featureaidesc3 = /** @type {(inputs: About_Featureaidesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your teaching needs in a single sentence, and AI generates animations, interactive components, experiment simulations, and rich educational content — dramatically lowering the creation barrier.`)
};

const es_about_featureaidesc3 = /** @type {(inputs: About_Featureaidesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe tus necesidades educativas en una sola frase y la IA genera animaciones, componentes interactivos, simulaciones de experimentos y contenido educativo enriquecido, reduciendo drásticamente las barreras de creación.`)
};

/**
* | output |
* | --- |
* | "Describe your teaching needs in a single sentence, and AI generates animations, interactive components, experiment simulations, and rich educational content ..." |
*
* @param {About_Featureaidesc3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featureaidesc3 = /** @type {((inputs?: About_Featureaidesc3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featureaidesc3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featureaidesc3(inputs)
	if (locale === "en") return en_about_featureaidesc3(inputs)
	return es_about_featureaidesc3(inputs)
});
export { about_featureaidesc3 as "about_featureAIDesc" }